module.exports = __webpack_public_path__ + "static/media/map2.6e80bdc0.png";